
      // Hard SW opt-out: if a service worker exists but PWA is disabled, unregister
      (function () {
        try {
          const fromWindow = (typeof window !== 'undefined' && window.__VITE__ && window.__VITE__.VITE_ENABLE_PWA) || undefined;
          const fromImportMeta = (import.meta && import.meta.env && import.meta.env.VITE_ENABLE_PWA) || undefined;
          const pwaEnabled = (fromWindow ?? fromImportMeta) === 'true';
          if ('serviceWorker' in navigator && !pwaEnabled) {
            navigator.serviceWorker.getRegistrations && navigator.serviceWorker.getRegistrations().then(regs => regs.forEach(r => r.unregister()));
            caches && caches.keys && caches.keys().then(keys => Promise.all(keys.map(k => caches.delete(k))));
          }
        } catch (e) {}
      })();
    